(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    ready(function () {
      document.querySelectorAll('[data-zn-countdown]').forEach(function (timer) {
        var endRaw = timer.getAttribute('data-end') || '';
        var target = Date.parse(String(endRaw).replace(' ', 'T'));
        if (isNaN(target)) {
          target = Date.now() + (3 * 24 * 3600 + 9 * 3600 + 18 * 60) * 1000;
        }
        var d = timer.querySelector('[data-d]');
        var h = timer.querySelector('[data-h]');
        var m = timer.querySelector('[data-m]');
        var s = timer.querySelector('[data-s]');
        function tick() {
          var diff = Math.max(0, target - Date.now());
          var sec = Math.floor(diff / 1000);
          var dd = Math.floor(sec / 86400); sec -= dd * 86400;
          var hh = Math.floor(sec / 3600); sec -= hh * 3600;
          var mm = Math.floor(sec / 60); sec -= mm * 60;
          if (d) d.textContent = pad(dd);
          if (h) h.textContent = pad(hh);
          if (m) m.textContent = pad(mm);
          if (s) s.textContent = pad(sec);
        }
        tick();
        setInterval(tick, 1000);
      });

      document.querySelectorAll('[data-zn-rotator]').forEach(function (rot) {
        var msgs = rot.querySelectorAll('.zn-msg');
        if (msgs.length < 2) return;
        var i = 0;
        setInterval(function () {
          msgs[i].classList.remove('zn-on');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('zn-on');
        }, 3200);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function ready(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }
    ready(function(){
      var root=document.querySelector('[data-zn-clist]');
      if(!root) return;
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{threshold:.12});
      root.querySelectorAll('.zn-clist__card').forEach(function(c){
        c.style.opacity='0'; c.style.transform='translateY(18px)'; c.style.transition='opacity .6s ease, transform .6s cubic-bezier(.2,.6,.2,1)';
        io.observe(c);
      });
      if(!document.getElementById('zn-clist-in')){
        var style=document.createElement('style');
        style.id='zn-clist-in';
        style.textContent='.zn-clist__card.is-in{opacity:1!important;transform:none!important} .zn-clist__card.is-disabled{opacity:.62!important}';
        document.head.appendChild(style);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-zn-collection]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var allDetails = root.querySelectorAll('details.zn-filter[data-zn-filter]');
    allDetails.forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (det.open) {
          allDetails.forEach(function (other) {
            if (other !== det && other.open) other.open = false;
          });
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-zn-filters]')) {
        allDetails.forEach(function (d) { d.open = false; });
      }
    });

    var filterInputs = root.querySelectorAll('[data-zn-filter-input]');
    function buildFilterURL() {
      var url = new URL(window.location.href);
      var sort = url.searchParams.get('sort_by');
      var newParams = new URLSearchParams();
      if (sort) newParams.set('sort_by', sort);
      filterInputs.forEach(function (inp) {
        if (inp.type === 'checkbox') {
          if (inp.checked) newParams.append(inp.name, inp.value);
        } else if (inp.type === 'number' && inp.value) {
          newParams.set(inp.name, inp.value);
        }
      });
      url.search = newParams.toString();
      return url.toString();
    }
    filterInputs.forEach(function (inp) {
      if (inp.type === 'checkbox') {
        inp.addEventListener('change', function () {
          var label = inp.closest('.zn-filter__opt');
          if (label) label.classList.toggle('is-on', inp.checked);
          setTimeout(function () { window.location.href = buildFilterURL(); }, 180);
        });
      }
    });
    root.querySelectorAll('[data-zn-filter-apply]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = buildFilterURL(); });
    });
    root.querySelectorAll('[data-zn-filter-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        var det = b.closest('details');
        if (!det) return;
        det.querySelectorAll('input').forEach(function (i) {
          if (i.type === 'checkbox') {
            i.checked = false;
            var lb = i.closest('.zn-filter__opt');
            if (lb) lb.classList.remove('is-on');
          } else i.value = '';
        });
      });
    });

    var sortSel = root.querySelector('[data-zn-sort-select]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        window.location.href = url.toString();
      });
    }

    root.querySelectorAll('.zn-prod__img--2').forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-ready');
    });
    root.querySelectorAll('.zn-chip[data-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.classList.toggle('is-on');
        var q = chip.classList.contains('is-on') ? (chip.getAttribute('data-chip') || '').toLowerCase() : '';
        var grid = root.querySelector('[data-zn-grid]');
        if (!grid) return;
        grid.querySelectorAll('.zn-prod').forEach(function (card) {
          var t = ((card.querySelector('.zn-prod__title') || {}).textContent || '').toLowerCase();
          card.style.display = (!q || t.indexOf(q) > -1) ? '' : 'none';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function readyImg(img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-ready');
    }

    function bind(root) {
      if (!root || root.dataset.znBound) return;
      root.dataset.znBound = '1';
      root.querySelectorAll('.zn-pcard__img--secondary').forEach(readyImg);

      var track = root.querySelector('[data-zn-feat-track]');
      if (!track || root.getAttribute('data-layout') !== 'carousel') return;

      var prevs = root.querySelectorAll('[data-zn-feat-prev]');
      var nexts = root.querySelectorAll('[data-zn-feat-next]');
      var dotsBox = root.querySelector('[data-zn-feat-dots]');

      function slideStep() {
        var cell = track.querySelector('.zn-feat__cell');
        if (!cell) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 22;
        return cell.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth - 2);
      }

      function isOverflow() {
        return track.scrollWidth > track.clientWidth + 4;
      }

      function pageCount() {
        return Math.max(1, Math.ceil((track.scrollWidth - 2) / (track.clientWidth || 1)));
      }

      function currentPage() {
        var max = maxScroll();
        if (max <= 0) return 0;
        var pages = pageCount();
        return Math.round((track.scrollLeft / max) * (pages - 1));
      }

      function renderDots() {
        if (!dotsBox) return;
        if (!isOverflow()) {
          dotsBox.hidden = true;
          dotsBox.innerHTML = '';
          return;
        }
        var n = pageCount();
        var on = currentPage();
        dotsBox.hidden = false;
        dotsBox.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'zn-feat__dot' + (i === on ? ' is-on' : '');
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.dataset.page = String(i);
          dotsBox.appendChild(b);
        }
      }

      function sync() {
        var overflow = isOverflow();
        root.classList.toggle('is-grid', !overflow);
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= maxScroll();
        prevs.forEach(function (btn) { btn.disabled = !overflow || atStart; });
        nexts.forEach(function (btn) { btn.disabled = !overflow || atEnd; });
        renderDots();
      }

      function go(dir) {
        track.scrollBy({ left: dir * slideStep(), behavior: 'smooth' });
      }

      prevs.forEach(function (btn) { btn.addEventListener('click', function () { go(-1); }); });
      nexts.forEach(function (btn) { btn.addEventListener('click', function () { go(1); }); });

      if (dotsBox) {
        dotsBox.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-page]');
          if (!btn) return;
          var page = parseInt(btn.dataset.page, 10) || 0;
          var max = maxScroll();
          var pages = Math.max(1, pageCount() - 1);
          track.scrollTo({ left: pages ? (page / pages) * max : 0, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });

      sync();
    }

    document.querySelectorAll('[data-zn-feat]').forEach(bind);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector('[data-zn-feat]');
      if (root) bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }
    ready(function () {
      var header = document.querySelector('[data-zn-header]');
      if (!header) return;
      var mode = header.getAttribute('data-sticky-mode') || 'always';
      var condense = header.getAttribute('data-condense') === '1';
      var btt = document.querySelector('[data-zn-btt]');
      var headerSection = header.closest('.shopify-section');
      var pageWrap = document.querySelector('.page-wrapper');
      var lastY = 0, tick = false;
      function scrollYNow() {
        if (pageWrap) {
          var st = pageWrap.scrollTop;
          if (st > 0 || pageWrap.scrollHeight > pageWrap.clientHeight + 4) return st;
        }
        return window.scrollY || document.documentElement.scrollTop || 0;
      }
      function stickyUpd() {
        tick = false;
        var y = scrollYNow();
        if (mode !== 'none') {
          header.classList.toggle('zn-header--stuck', y > 8);
          if (condense) header.classList.toggle('zn-header--compact', y > 36);
          else header.classList.remove('zn-header--compact');
          if (mode === 'smart') {
            if (y > 280 && y > lastY + 2) {
              header.classList.add('zn-header--up');
              if (headerSection) headerSection.classList.add('zn-header-section--up');
            } else if (y < lastY - 2 || y <= 280) {
              header.classList.remove('zn-header--up');
              if (headerSection) headerSection.classList.remove('zn-header-section--up');
            }
          }
        }
        if (btt) btt.classList.toggle('is-on', y > 520);
        lastY = y;
      }
      function onScroll() { if (!tick) { tick = true; requestAnimationFrame(stickyUpd); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      if (pageWrap) pageWrap.addEventListener('scroll', onScroll, { passive: true });
      stickyUpd();
      if (btt) btt.addEventListener('click', function () {
        if (pageWrap && pageWrap.scrollHeight > pageWrap.clientHeight + 4) pageWrap.scrollTo({ top: 0, behavior: 'smooth' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      /* Desktop: parent/child with submenu opens on click, no redirect */
      var navItems = header.querySelectorAll('[data-zn-nav-item]');
      function closeAllNav(except) {
        navItems.forEach(function (li) {
          if (li !== except) {
            li.classList.remove('is-open');
            var t = li.querySelector('[data-zn-nav-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
            li.querySelectorAll('[data-zn-nav-subitem].is-open').forEach(function (s) {
              s.classList.remove('is-open');
              var st = s.querySelector('[data-zn-nav-subtoggle]');
              if (st) st.setAttribute('aria-expanded', 'false');
            });
          }
        });
      }
      navItems.forEach(function (li) {
        var toggle = li.querySelector('[data-zn-nav-toggle]');
        if (toggle) {
          toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var willOpen = !li.classList.contains('is-open');
            closeAllNav(li);
            li.classList.toggle('is-open', willOpen);
            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          });
        }
        li.querySelectorAll('[data-zn-nav-subitem]').forEach(function (sub) {
          var st = sub.querySelector('[data-zn-nav-subtoggle]');
          if (st) {
            st.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var willOpen = !sub.classList.contains('is-open');
              li.querySelectorAll('[data-zn-nav-subitem].is-open').forEach(function (o) {
                if (o !== sub) {
                  o.classList.remove('is-open');
                  var ot = o.querySelector('[data-zn-nav-subtoggle]');
                  if (ot) ot.setAttribute('aria-expanded', 'false');
                }
              });
              sub.classList.toggle('is-open', willOpen);
              st.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            });
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-zn-nav-item]')) closeAllNav(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAllNav(null);
      });

      var drawer = document.querySelector('[data-zn-drawer]');
      var scrim = document.querySelector('[data-zn-scrim]');
      var burger = document.querySelector('[data-zn-burger]');
      if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
      if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
      var stack = ['root'];
      function showPanel(id) {
        if (!drawer) return;
        drawer.querySelectorAll('[data-panel]').forEach(function (p) {
          p.classList.remove('is-active', 'is-behind');
          if (p.getAttribute('data-panel') === id) p.classList.add('is-active');
          else if (stack.indexOf(p.getAttribute('data-panel')) !== -1) p.classList.add('is-behind');
        });
      }
      function resetPanels() { stack = ['root']; showPanel('root'); }
      function openMenu() {
        resetPanels();
        if (drawer) { drawer.classList.add('zn-mnav--open'); drawer.setAttribute('aria-hidden','false'); }
        if (scrim) scrim.classList.add('zn-mnav--open');
        document.body.style.overflow = 'hidden';
      }
      function closeMenu() {
        if (drawer) { drawer.classList.remove('zn-mnav--open'); drawer.setAttribute('aria-hidden','true'); }
        if (scrim) scrim.classList.remove('zn-mnav--open');
        document.body.style.overflow = '';
        resetPanels();
      }
      if (burger) burger.addEventListener('click', openMenu);
      var closer = document.querySelector('[data-zn-close]');
      if (closer) closer.addEventListener('click', closeMenu);
      if (scrim) scrim.addEventListener('click', closeMenu);
      if (drawer) {
        drawer.querySelectorAll('[data-zn-loc]').forEach(function (sel) {
          sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
        });
        drawer.querySelectorAll('[data-zn-goto]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-zn-goto');
            stack.push(id); showPanel(id);
          });
        });
        drawer.querySelectorAll('[data-zn-back]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (stack.length > 1) stack.pop();
            showPanel(stack[stack.length - 1]);
          });
        });
      }
      document.querySelectorAll('[data-zn-open-search]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openMenu();
          setTimeout(function () {
            var inp = document.querySelector('[data-zn-msearch-input]');
            if (inp) inp.focus();
          }, 380);
        });
      });

      function cartDrawerEl() {
        return document.getElementById('cart-drawer') || document.querySelector('theme-drawer#cart-drawer, cart-drawer-component, cart-drawer');
      }
      function openCartDrawer() {
        var d = cartDrawerEl();
        if (!d) return false;
        closeMenu();
        if (typeof d.open === 'function') { d.open(); return true; }
        var inner = d.querySelector && d.querySelector('theme-drawer');
        if (inner && typeof inner.open === 'function') { inner.open(); return true; }
        if (typeof d.showModal === 'function' && !d.open) { d.showModal(); return true; }
        d.setAttribute('open', '');
        return true;
      }
      function releasePageSqueeze() {
        if (pageWrap) {
          pageWrap.classList.remove('page-wrapper--drawer-open');
          pageWrap.style.setProperty('margin-inline-end', '0', 'important');
        }
        document.documentElement.classList.remove('page-wrapper--drawer-open');
      }
      if (pageWrap && window.MutationObserver) {
        new MutationObserver(function () {
          if (pageWrap.classList.contains('page-wrapper--drawer-open')) releasePageSqueeze();
        }).observe(pageWrap, { attributes: true, attributeFilter: ['class'] });
      }
      releasePageSqueeze();
      function closeCartDrawer() {
        var d = cartDrawerEl();
        if (!d) return;
        d.setAttribute('no-persist', '');
        if (typeof d.close === 'function') d.close();
        else {
          var dlg = d.querySelector && d.querySelector('dialog');
          if (dlg && typeof dlg.close === 'function') dlg.close();
          d.removeAttribute('open');
        }
        var innerDlg = d.querySelector && d.querySelector('dialog[open]');
        if (innerDlg && typeof innerDlg.close === 'function') innerDlg.close();
        d.removeAttribute('open');
        if (cartScrim) cartScrim.classList.remove('is-on');
        releasePageSqueeze();
        try { sessionStorage.removeItem('theme-drawer-open'); } catch (err) {}
      }
      var SKIP_CART = 'zn-skip-cart-autoopen';
      function skipCartOpen() {
        try { return sessionStorage.getItem(SKIP_CART) === '1'; } catch (err) { return false; }
      }
      function markSkipCartOpen() {
        try { sessionStorage.setItem(SKIP_CART, '1'); } catch (err) {}
      }
      function clearSkipCartOpen() {
        try { sessionStorage.removeItem(SKIP_CART); } catch (err) {}
      }
      function collectionsUrl() {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        return root.replace(/\/?$/, '/') + 'collections';
      }
      function goCollectionsFromCart() {
        markSkipCartOpen();
        try { sessionStorage.removeItem('theme-drawer-open'); } catch (err) {}
        var d = cartDrawerEl();
        if (d) d.setAttribute('no-persist', '');
        releasePageSqueeze();
        window.location.href = collectionsUrl();
      }
      var cartScrim = document.querySelector('[data-zn-cart-scrim]');
      if (!cartScrim) {
        cartScrim = document.createElement('div');
        cartScrim.className = 'zn-cart-scrim';
        cartScrim.setAttribute('data-zn-cart-scrim', '');
        document.body.appendChild(cartScrim);
      }
      cartScrim.addEventListener('click', function () { closeCartDrawer(); });
      var persistDrawer = cartDrawerEl();
      if (persistDrawer) persistDrawer.setAttribute('no-persist', '');
      document.addEventListener('theme-drawer:open', function (e) {
        var t = e.target;
        if (t && t.id === 'cart-drawer') {
          if (skipCartOpen()) { closeCartDrawer(); return; }
          cartScrim.classList.add('is-on');
        }
        requestAnimationFrame(releasePageSqueeze);
      }, true);
      document.addEventListener('theme-drawer:open', function () {
        requestAnimationFrame(releasePageSqueeze);
      });
      document.addEventListener('theme-drawer:close', function () {
        if (!document.querySelector('#cart-drawer[open]')) cartScrim.classList.remove('is-on');
      });
      document.querySelectorAll('.zn-cart').forEach(function (cartBtn) {
        cartBtn.addEventListener('click', function (e) {
          if (openCartDrawer()) e.preventDefault();
        });
      });

      function isContinueBtn(el) {
        if (!el) return null;
        var btn = el.closest ? el.closest('a.cart-items__empty-button, .cart-items__empty-button, a.button') : null;
        if (!btn) return null;
        var label = (btn.textContent || '').replace(/\s+/g, ' ').trim();
        if (/continue shopping/i.test(label) || btn.classList.contains('cart-items__empty-button')) return btn;
        return null;
      }
      function onContinuePointer(e) {
        var drawer = cartDrawerEl();
        if (!drawer || !drawer.contains(e.target)) return;
        var btn = isContinueBtn(e.target);
        if (!btn || !drawer.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        goCollectionsFromCart();
      }
      document.addEventListener('pointerdown', onContinuePointer, true);
      document.addEventListener('click', onContinuePointer, true);

      function keepCartShut() {
        closeCartDrawer();
        var d = cartDrawerEl();
        if (d) {
          d.removeAttribute('open');
          d.setAttribute('no-persist', '');
          var dlg = d.querySelector && d.querySelector('dialog');
          if (dlg) {
            if (typeof dlg.close === 'function' && dlg.open) dlg.close();
            dlg.removeAttribute('open');
          }
        }
        releasePageSqueeze();
      }
      function watchShutEmptyCart() {
        var comp = document.querySelector('cart-drawer-component');
        if (comp) comp.removeAttribute('auto-open');
        keepCartShut();
        var n = 0;
        var iv = setInterval(function () {
          keepCartShut();
          if (++n > 40) {
            clearInterval(iv);
            clearSkipCartOpen();
            if (comp) comp.setAttribute('auto-open', '');
          }
        }, 50);
        var d = cartDrawerEl();
        if (d && window.MutationObserver) {
          var mo = new MutationObserver(function () { keepCartShut(); });
          mo.observe(d, { attributes: true, attributeFilter: ['open'] });
          setTimeout(function () { mo.disconnect(); }, 2500);
        }
      }
      if (skipCartOpen()) watchShutEmptyCart();
      window.addEventListener('pageshow', function () {
        if (skipCartOpen()) watchShutEmptyCart();
      });

      function setCartCount(n) {
        n = parseInt(n, 10);
        if (isNaN(n) || n < 0) n = 0;
        document.querySelectorAll('.zn-cart').forEach(function (btn) {
          btn.setAttribute('data-zn-cart-count', String(n));
          var badge = btn.querySelector('.zn-badge');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'zn-badge';
            btn.appendChild(badge);
          }
          badge.setAttribute('data-n', String(n));
          badge.textContent = n > 0 ? (n > 99 ? '99+' : String(n)) : '';
        });
        try {
          sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
        } catch (err) {}
      }
      function refreshCartCount() {
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCartCount(cart.item_count != null ? cart.item_count : cart.totalQuantity); })
          .catch(function () {});
      }
      function countFromDetail(d) {
        if (!d) return null;
        if (typeof d.item_count === 'number') return d.item_count;
        if (typeof d.itemCount === 'number') return d.itemCount;
        if (typeof d.totalQuantity === 'number') return d.totalQuantity;
        if (d.cart) {
          if (typeof d.cart.item_count === 'number') return d.cart.item_count;
          if (typeof d.cart.totalQuantity === 'number') return d.cart.totalQuantity;
        }
        if (d.data && typeof d.data.itemCount === 'number') return d.data.itemCount;
        return null;
      }
      function onCartEvent(e) {
        var n = countFromDetail(e && e.detail);
        if (typeof n === 'number') { setCartCount(n); return; }
        var p = e && e.promise;
        if (p && typeof p.then === 'function') {
          p.then(function (res) {
            var nn = countFromDetail(res) || countFromDetail(res && res.detail) || (res && res.cart && (res.cart.totalQuantity != null ? res.cart.totalQuantity : res.cart.item_count));
            if (typeof nn === 'number') setCartCount(nn);
            else refreshCartCount();
          }).catch(function () { refreshCartCount(); });
          return;
        }
        refreshCartCount();
      }
      ['shopify:cart:update', 'shopify:cart:change', 'shopify:cart:lines-update', 'cart:lines-update', 'cart:update', 'cart:updated', 'cart:change', 'theme:cart:update'].forEach(function (ev) {
        document.addEventListener(ev, onCartEvent);
      });
      var origFetch = window.fetch;
      if (typeof origFetch === 'function' && !window.__znCartFetch) {
        window.__znCartFetch = true;
        window.fetch = function () {
          var args = arguments;
          return origFetch.apply(this, args).then(function (res) {
            try {
              var u = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
              if (/\/cart\/(add|update|change|clear)/.test(u)) {
                var copy = res.clone();
                copy.json().then(function (data) {
                  var n = data && (data.item_count != null ? data.item_count : data.totalQuantity);
                  if (typeof n === 'number') setCartCount(n);
                  else refreshCartCount();
                }).catch(function () { refreshCartCount(); });
              }
            } catch (err) {}
            return res;
          });
        };
      }
      document.addEventListener('submit', function (e) {
        var f = e.target && e.target.closest ? e.target.closest('form[action*="/cart"]') : null;
        if (f) setTimeout(refreshCartCount, 700);
      });
      window.addEventListener('pageshow', function () { refreshCartCount(); });

      var search = header.querySelector('[data-zn-search]');
      if (search) {
        var input = search.querySelector('[data-zn-input]');
        var panel = search.querySelector('[data-zn-panel]');
        var clearBtn = search.querySelector('[data-zn-clear]');
        var trending = search.querySelector('[data-zn-trending]');
        var chips = search.querySelector('[data-zn-chips]');
        var results = search.querySelector('[data-zn-results]');
        var popular = (header.getAttribute('data-trending') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        var timer = null;
        chips.innerHTML = popular.map(function (t) {
          return '<button type="button" class="zn-search__chip" data-q="' + esc(t) + '">' + esc(t) + '</button>';
        }).join('');
        function showTrending() { trending.style.display = 'block'; results.innerHTML = ''; }
        function render(data) {
          var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (!prods.length) {
            results.innerHTML = '<div class="zn-search__empty">No results — press Enter to search everything.</div>';
            return;
          }
          trending.style.display = 'none';
          results.innerHTML = prods.slice(0, 6).map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            return '<a class="zn-search__item" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="">' : '') +
              '<span class="zn-search__t"><b>' + esc(p.title) + '</b></span>' +
              '<span class="zn-search__p"><b>' + esc(p.price) + '</b></span></a>';
          }).join('');
        }
        input.addEventListener('focus', function () { panel.classList.add('zn-search--open'); if (!input.value.trim()) showTrending(); });
        input.addEventListener('input', function () {
          var q = input.value.trim();
          panel.classList.add('zn-search--open');
          clearBtn.classList.toggle('zn-search--show', !!q);
          if (!q) { showTrending(); return; }
          clearTimeout(timer);
          timer = setTimeout(function () {
            fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
              .then(function (r) { return r.json(); })
              .then(render)
              .catch(function () {});
          }, 220);
        });
        clearBtn.addEventListener('click', function () {
          input.value = ''; showTrending(); clearBtn.classList.remove('zn-search--show'); input.focus();
        });
        document.addEventListener('click', function (e) {
          if (!search.contains(e.target)) panel.classList.remove('zn-search--open');
        });
        chips.addEventListener('click', function (e) {
          var c = e.target.closest('[data-q]');
          if (c) window.location.href = '/search?q=' + encodeURIComponent(c.getAttribute('data-q') || '');
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMenu();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (root.getAttribute('data-zn-booted')) return;
      root.setAttribute('data-zn-booted', '1');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-zn-slide]'));
      if (!slides.length) return;
      if (slides.length === 1) root.classList.add('zn-hero--solo');
      var dotsWrap = root.querySelector('[data-zn-dots]');
      var indexEl = root.querySelector('[data-zn-index]');
      var autoplay = root.getAttribute('data-autoplay') !== '0';
      var interval = parseInt(root.getAttribute('data-interval') || '6500', 10);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0;
      var timer = null;
      var n = slides.length;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function paint(next) {
        i = (next + n) % n;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        if (dotsWrap) {
          dotsWrap.querySelectorAll('[data-zn-dot]').forEach(function (d, k) {
            d.classList.toggle('is-on', k === i);
            d.setAttribute('aria-selected', k === i ? 'true' : 'false');
          });
        }
        if (indexEl) indexEl.innerHTML = '<b>' + pad(i + 1) + '</b> / ' + pad(n);
        slides.forEach(function (s, k) {
          var v = s.querySelector('video');
          if (!v) return;
          if (k === i) { v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }
      function arm() {
        clearInterval(timer);
        if (!autoplay || reduce || n < 2) return;
        timer = setInterval(function () { paint(i + 1); }, interval);
      }
      if (dotsWrap && !dotsWrap.children.length) {
        slides.forEach(function (_, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'zn-hero__dot' + (k === 0 ? ' is-on' : '');
          b.setAttribute('data-zn-dot', '');
          b.setAttribute('aria-label', 'Slide ' + (k + 1));
          b.addEventListener('click', function () { paint(k); arm(); });
          dotsWrap.appendChild(b);
        });
      }
      var prev = root.querySelector('[data-zn-prev]');
      var next = root.querySelector('[data-zn-next]');
      if (prev) prev.addEventListener('click', function () { paint(i - 1); arm(); });
      if (next) next.addEventListener('click', function () { paint(i + 1); arm(); });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', arm);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearInterval(timer); else arm();
      });
      paint(0);
      arm();
    }
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
      document.querySelectorAll('[data-zn-hero]').forEach(boot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-zn-pdp]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.zn-rel-img--2').forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-ready');
      else img.addEventListener('load', function () { img.classList.add('is-ready'); }, { once: true });
    });
    var qty = 1;
    var qtyOutput = root.querySelector('[data-qty-output]');
    var qtyWrap = root.querySelector('[data-zn-qty]');
    var addBtn = root.querySelector('[data-zn-add]');
    var addedBox = root.querySelector('[data-zn-added]');
    var priceNow = root.querySelector('[data-zn-price-now]');
    var priceWas = root.querySelector('[data-zn-price-was]');
    var priceOff = root.querySelector('[data-zn-price-off]');
    var stockEl = root.querySelector('[data-zn-stock]');

    function syncQty() { if (qtyOutput) qtyOutput.textContent = String(qty); }
    if (qtyWrap) {
      var minus = qtyWrap.querySelector('[data-minus]');
      var plus = qtyWrap.querySelector('[data-plus]');
      if (minus) minus.addEventListener('click', function () { if (qty > 1) { qty--; syncQty(); } });
      if (plus) plus.addEventListener('click', function () { if (qty < 9) { qty++; syncQty(); } });
    }
    syncQty();

    function routesRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }

    var chips = root.querySelectorAll('.zn-chip[data-variant-id]');
    function updateVariantUI(chip) {
      if (!chip) return;
      var available = chip.getAttribute('data-available') === 'true';
      var priceFmt = chip.getAttribute('data-price-fmt') || '';
      var compareFmt = chip.getAttribute('data-compare-fmt') || '';
      var price = parseInt(chip.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(chip.getAttribute('data-compare') || '0', 10) || 0;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', chip.getAttribute('data-variant-id'));
        addBtn.disabled = !available;
        var addText = root.querySelector('[data-zn-add-text]');
        if (addText) {
          addText.innerHTML = available
            ? 'Add to bag — <span data-zn-add-price>' + priceFmt + '</span>'
            : 'Sold out';
        }
      }
      var floatAdd = document.querySelector('[data-zn-float-add]');
      var floatPrice = document.querySelector('[data-zn-float-price]');
      if (floatAdd) {
        floatAdd.setAttribute('data-variant-id', chip.getAttribute('data-variant-id'));
        floatAdd.disabled = !available;
        floatAdd.textContent = available ? 'Add to bag' : 'Sold out';
      }
      if (floatPrice && priceFmt) floatPrice.textContent = priceFmt;
      if (priceNow) priceNow.textContent = priceFmt;
      if (compare > price && compareFmt) {
        var save = Math.round((1 - price / compare) * 100);
        if (priceWas) { priceWas.textContent = compareFmt; priceWas.hidden = false; }
        if (priceOff) { priceOff.textContent = 'Save ' + save + '%'; priceOff.hidden = false; }
      } else {
        if (priceWas) priceWas.hidden = true;
        if (priceOff) priceOff.hidden = true;
      }
      if (stockEl) {
        stockEl.classList.toggle('is-out', !available);
        if (!available) stockEl.textContent = 'Out of stock';
        else {
          var inv = parseInt(chip.getAttribute('data-inventory'), 10);
          var manages = chip.getAttribute('data-inventory-management');
          if (manages && manages !== '' && manages !== 'null' && !isNaN(inv)) {
            if (inv <= 0) stockEl.textContent = 'Out of stock';
            else if (inv <= 5) stockEl.textContent = 'Only ' + inv + (inv === 1 ? ' piece' : ' pieces') + ' left';
            else stockEl.textContent = inv + ' pieces available';
          } else stockEl.textContent = 'In stock — ready to ship';
        }
      }
      var mediaId = chip.getAttribute('data-media-id');
      if (mediaId) showSlide(mediaId);
      var payId = root.querySelector('[data-zn-pay-id]');
      if (payId) payId.value = chip.getAttribute('data-variant-id');
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        updateVariantUI(chip);
      });
    });

    var slides = root.querySelectorAll('[data-zn-slide]');
    var thumbs = root.querySelectorAll('.zn-pdp__thumb[data-media-id]');
    var floatImg = document.querySelector('img[data-zn-float-img]');
    function showSlide(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (img) {
        var on = img.getAttribute('data-media-id') === id;
        img.classList.toggle('is-on', on);
        if (on) found = true;
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === id);
      });
      var onSlide = root.querySelector('[data-zn-slide].is-on');
      if (floatImg && onSlide) floatImg.src = onSlide.currentSrc || onSlide.src;
    }
    thumbs.forEach(function (th) {
      var id = th.getAttribute('data-media-id');
      th.addEventListener('mouseenter', function () { showSlide(id); });
      th.addEventListener('focus', function () { showSlide(id); });
      th.addEventListener('click', function () {
        showSlide(id);
      });
    });
    var thumbTrack = root.querySelector('[data-zn-thumbs]');
    var prevT = root.querySelector('[data-zn-thumbs-prev]');
    var nextT = root.querySelector('[data-zn-thumbs-next]');
    function syncThumbNav() {
      if (!thumbTrack || !prevT || !nextT) return;
      var max = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
      var overflow = max > 4;
      prevT.hidden = nextT.hidden = !overflow;
      if (!overflow) return;
      prevT.disabled = thumbTrack.scrollLeft <= 2;
      nextT.disabled = thumbTrack.scrollLeft >= max - 2;
    }
    function slideThumbs(dir) {
      if (!thumbTrack) return;
      thumbTrack.scrollBy({ left: dir * 96, behavior: 'smooth' });
    }
    if (prevT) prevT.addEventListener('click', function () { slideThumbs(-1); });
    if (nextT) nextT.addEventListener('click', function () { slideThumbs(1); });
    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', syncThumbNav, { passive: true });
      window.addEventListener('resize', syncThumbNav);
      syncThumbNav();
      thumbTrack.querySelectorAll('img').forEach(function (img) {
        if (img.complete) syncThumbNav();
        else img.addEventListener('load', syncThumbNav, { once: true });
      });
    }

    function pingCart(promise) {
      ['shopify:cart:update', 'shopify:cart:lines-update', 'cart:update', 'cart:updated'].forEach(function (name) {
        var ev = new CustomEvent(name, { bubbles: true });
        try { Object.defineProperties(ev, { promise: { value: promise }, action: { value: 'add' } }); } catch (e) {}
        document.dispatchEvent(ev);
      });
    }
    function openCartDrawer() {
      var d = document.getElementById('cart-drawer') || document.querySelector('theme-drawer#cart-drawer');
      if (!d) return;
      if (typeof d.open === 'function') { try { d.open(); } catch (e) {} }
      else d.setAttribute('open', '');
    }
    function addToCart(variantId, quantity, btn) {
      if (!variantId) return;
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', quantity);
      var rootPath = routesRoot().replace(/\/?$/, '/');
      fetch(rootPath + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        })
        .then(function () { return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          pingCart(Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } }));
          openCartDrawer();
          if (addedBox) { addedBox.hidden = false; setTimeout(function () { addedBox.hidden = true; }, 4000); }
          if (btn) { btn.innerHTML = '✓ Added'; setTimeout(function () { btn.disabled = false; btn.innerHTML = original; }, 1400); }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        });
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addToCart(addBtn.getAttribute('data-variant-id'), qty, addBtn);
      });
    }
    var floatBar = document.querySelector('[data-zn-float]');
    var floatAddBtn = document.querySelector('[data-zn-float-add]');
    if (floatAddBtn) {
      floatAddBtn.addEventListener('click', function () {
        addToCart(floatAddBtn.getAttribute('data-variant-id'), qty, floatAddBtn);
      });
    }
    root.querySelectorAll('[data-zn-rel-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), 1, btn);
      });
    });

    function setFloat(on) {
      if (!floatBar) return;
      floatBar.hidden = !on;
    }
    var watchEl = root.querySelector('[data-zn-buy-block]') || addBtn;
    if (floatBar && watchEl && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var vis = entries[0] && entries[0].isIntersecting;
        setFloat(!vis);
      }, { threshold: 0.05, rootMargin: '0px' });
      io.observe(watchEl);
    } else if (floatBar) {
      setFloat(true);
    }
    window.addEventListener('scroll', function () {
      if (!floatBar || !watchEl) return;
      var r = watchEl.getBoundingClientRect();
      setFloat(r.bottom < 80);
    }, { passive: true });

    var guide = root.querySelector('[data-zn-guide]');
    function openGuide(e) {
      if (e) e.preventDefault();
      if (!guide) return;
      if (typeof guide.showModal === 'function') guide.showModal();
      else guide.setAttribute('open', '');
    }
    function closeGuide() {
      if (!guide) return;
      if (typeof guide.close === 'function') guide.close();
      else guide.removeAttribute('open');
    }
    root.querySelectorAll('[data-zn-guide-open]').forEach(function (el) {
      el.addEventListener('click', openGuide);
    });
    var guideClose = root.querySelector('[data-zn-guide-close]');
    if (guideClose) guideClose.addEventListener('click', closeGuide);
    if (guide) {
      guide.addEventListener('click', function (e) {
        if (e.target === guide) closeGuide();
      });
      guide.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeGuide();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zn-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-zn-search]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var allDetails = root.querySelectorAll('details.zn-filter[data-zn-filter]');
    allDetails.forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (det.open) {
          allDetails.forEach(function (other) {
            if (other !== det && other.open) other.open = false;
          });
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-zn-filters]')) {
        allDetails.forEach(function (d) { d.open = false; });
      }
    });

    var filterInputs = root.querySelectorAll('[data-zn-filter-input]');
    function buildFilterURL() {
      var url = new URL(window.location.href);
      var sort = url.searchParams.get('sort_by');
      var q = url.searchParams.get('q');
      var type = url.searchParams.get('type');
      var newParams = new URLSearchParams();
      if (q) newParams.set('q', q);
      if (type) newParams.set('type', type);
      if (sort) newParams.set('sort_by', sort);
      filterInputs.forEach(function (inp) {
        if (inp.type === 'checkbox') {
          if (inp.checked) newParams.append(inp.name, inp.value);
        } else if (inp.type === 'number' && inp.value) {
          newParams.set(inp.name, inp.value);
        }
      });
      url.search = newParams.toString();
      return url.toString();
    }
    filterInputs.forEach(function (inp) {
      if (inp.type === 'checkbox') {
        inp.addEventListener('change', function () {
          var label = inp.closest('.zn-filter__opt');
          if (label) label.classList.toggle('is-on', inp.checked);
          setTimeout(function () { window.location.href = buildFilterURL(); }, 180);
        });
      }
    });
    root.querySelectorAll('[data-zn-filter-apply]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = buildFilterURL(); });
    });
    root.querySelectorAll('[data-zn-filter-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        var det = b.closest('details');
        if (!det) return;
        det.querySelectorAll('input').forEach(function (i) {
          if (i.type === 'checkbox') {
            i.checked = false;
            var lb = i.closest('.zn-filter__opt');
            if (lb) lb.classList.remove('is-on');
          } else i.value = '';
        });
      });
    });

    var sortSel = root.querySelector('[data-zn-sort-select]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        window.location.href = url.toString();
      });
    }

    root.querySelectorAll('.zn-chip[data-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.classList.toggle('is-on');
        var q = chip.classList.contains('is-on') ? (chip.getAttribute('data-chip') || '').toLowerCase() : '';
        var grid = root.querySelector('[data-zn-grid]');
        if (!grid) return;
        grid.querySelectorAll('.zn-prod').forEach(function (card) {
          var t = ((card.querySelector('.zn-prod__title') || {}).textContent || '').toLowerCase();
          card.style.display = (!q || t.indexOf(q) > -1) ? '' : 'none';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
